import type { FeaturedPitchesStoryblok } from "@/component-types-sb";
import { Card } from "@/components/layout/Card";
import { BodyText, Divider, H2 } from "@/components/typography";
import { storyblokEditable } from "@storyblok/react/rsc";
import { Fragment } from "react";

type FeaturedPitchesPops = {
  blok: FeaturedPitchesStoryblok;
};

const FeaturedPitches = ({ blok }: FeaturedPitchesPops) => (
  <section
    className="py-8 mx-2 lg:mx-4  text-center"
    {...storyblokEditable(blok)}
  >
    {blok.headline && (
      <Fragment>
        <H2 colorScheme="primary">{blok.headline}</H2>
        <BodyText className="max-w-2xl mx-auto mt-4 text-center">
          {blok.text}
        </BodyText>

        <Divider />
      </Fragment>
    )}

    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
      {blok.pitches?.map((nestedBlok: any) => (
        <Card
          key={nestedBlok.id}
          image={nestedBlok.content?.image}
          href={nestedBlok.full_slug}
          name={nestedBlok.name}
          text={nestedBlok.content?.lead}
        />
      ))}
    </div>
  </section>
);

FeaturedPitches.blockName = "featured_pitches";

export default FeaturedPitches;
